export const setupSnacks = (enqueueSnackbar) => {
    return {
        type: "SETUP_SNACK",
        payload: enqueueSnackbar,
    };
};
